import fetcher from "./http";

export default {
    list(appCode) {
        return new Promise((resolve, reject) => {
            fetcher(`/api/v1/${appCode}/payment-methods`, { method: "GET" })
                .then(response => response.json())
                .then(data => resolve(data))
                .catch(error => reject(error));
        });
    }
};
